import actionCreator from '../../../../../utils/actionCreator';

const expensesActionTypes = [
  'GET_EXPENSES',
  'GET_TREND',
  'GET_CHAIR_REVENUE',
  'CREATE_EXPENSE',
  'UPDATE_EXPENSE',
  'DELETE_EXPENSE',
  'DELETE_RECURRING_EXPENSE',
];

export const { types: expensesTypes, actions: expensesActions } =
  actionCreator(expensesActionTypes);
